import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AuthService from './../auth_components/js/AuthService';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import './navbar.css';

const styles = theme => ({});

const cellMenu = [
    
    { title: "Internship Providing Orgs", link: "/academics" },
    { title: "For Students", link: "/for-students" },
    { title: "Internship Division", link: "/internship-division" },
    { title: "Apprenticeship Division", link: "/apprenticeship-division" },
];

const collegeMenu = [
    { title: "College", link: "/college" },
    { title: "About Us", link: "/about-us" },
    
];

const mediaMenu = [
    { title: "Gallery", link: "/gallery" },
    { title: "Photos", link: "/photos" },
];

const systemMenu = [
    { title: "Users", link: "/users" },
    { title: "Logs", link: "/logs" },
];

const iqacMenu = [
    { title: "View All", link: "/view" },
    { title: "IQAC", link: "/iqac" },
];

class PrimarySearchAppBar extends React.Component {
    constructor(props) {
        super(props);
        this.Auth = new AuthService();
        let user1 = JSON.parse(localStorage.getItem('user'));
        this.state = user1 != null
            ? {
                apikey: user1.user.apikey,
                username: user1.user.email,
                name: user1.user.name,
                role: user1.user.role,
            }
            : { apikey: '', username: '', name: '', role: '' };
    }

    onLogout = () => {
        this.Auth.logout();
        this.props.history.replace('/login');
    };

    isActive = (link) => {
        if (typeof window === 'undefined') return false;
        return window.location.pathname === link;
    };

    isGroupActive = (items) => items.some((el) => this.isActive(el.link));

    go = (link) => {
        this.props.history.push(link);
    };

    renderDropdown = (title, items) => (
        <NavDropdown
            title={title}
            id={`nav-dropdown-${title.replace(/\s+/g, '-').toLowerCase()}`}
            className={`admin-nav-dropdown ${this.isGroupActive(items) ? 'active' : ''}`}
        >
            {items.map((el, idx) => (
                <NavDropdown.Item
                    key={idx}
                    onClick={() => this.go(el.link)}
                    active={this.isActive(el.link)}
                >
                    {el.title}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );

    renderInitials = () => {
        const source = this.state.name || this.state.username || '';
        if (!source) return 'A';
        const parts = source.split(/[\s@.]+/).filter(Boolean);
        const initials = (parts[0]?.[0] || '') + (parts[1]?.[0] || '');
        return initials.toUpperCase() || source[0].toUpperCase();
    };

    render() {
        const role = this.state.role;
        return (
            <Navbar
                expand="lg"
                className="admin-navbar"
                variant="dark"
                sticky="top"
            >
                <Navbar.Brand
                    onClick={() => this.go('/')}
                    className="admin-navbar-brand"
                >
                    <div className="admin-brand-mark">IAC</div>
                    <div className="admin-brand-text">
                        <div className="admin-brand-title">
                            Internship & Apprenticeship Cell
                        </div>
                        <div className="admin-brand-subtitle">
                            Dispur College &middot; Admin Console
                        </div>
                    </div>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="admin-navbar-nav" />

                <Navbar.Collapse id="admin-navbar-nav" className="justify-content-end">
                    <Nav className="admin-nav-items">
                        {role === 'SUPERADMIN' && (
                            <>
                                {this.renderDropdown('IAC-DC', cellMenu)}
                                {this.renderDropdown('College', collegeMenu)}
                                {this.renderDropdown('Media', mediaMenu)}
                                {this.renderDropdown('System', systemMenu)}
                            </>
                        )}

                        {role === 'IQAC' &&
                            iqacMenu.map((el, idx) => (
                                <Nav.Link
                                    key={idx}
                                    onClick={() => this.go(el.link)}
                                    className={`admin-nav-link ${this.isActive(el.link) ? 'active' : ''}`}
                                >
                                    {el.title}
                                </Nav.Link>
                            ))}
                    </Nav>

                    <div className="admin-nav-divider" />

                    <div className="admin-user-block">
                        <div className="admin-user-avatar" title={this.state.username}>
                            {this.renderInitials()}
                        </div>
                        <div className="admin-user-meta">
                            <div className="admin-user-name">
                                {this.state.name || this.state.username || 'Admin'}
                            </div>
                            {role && (
                                <span className="admin-user-role">{role}</span>
                            )}
                        </div>
                        <button
                            type="button"
                            onClick={this.onLogout}
                            className="admin-logout-btn"
                        >
                            Logout
                        </button>
                    </div>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default withStyles(styles)(PrimarySearchAppBar);
